export const Data = [
    {
        question: 'Who is Sambino?',
        answer: 'Sam (Sambino) is a software engineer with experience mainly in iOS app and game development. He also has some experience in graphic design, but in no way is he considering himself an artist.' 
    },
    {
        question: 'What charity is 30% of royalties going to?',
        answer: 'Sam is planning on donating to the International Otter Survival Fund (IOSF). They help fund multiple projects to help fight poaching and the fur/pet trades of Otters all over the world.' 
    }
];